import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AppLoadingShell from "./AppLoadingShell";
import { persistExtensionOpenedTab } from "../utils/extensionSession";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) return <AppLoadingShell />;

  if (!isAuthenticated) {
    const returnPath = `${location.pathname}${location.search || ""}`;
    if (returnPath && returnPath !== "/" && returnPath !== "/signin") {
      sessionStorage.setItem("redirectPath", returnPath);
    }
    persistExtensionOpenedTab();
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
